import { render, staticRenderFns } from "./Spacing.vue?vue&type=template&id=70bb273a&"
import script from "./Spacing.vue?vue&type=script&lang=js&"
export * from "./Spacing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports